/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectFinalStates} from "./searchObjects"



export function fillSearchObjectFinalStates(){
    searchObjectFinalStates.categories = [];
    searchObjectFinalStates.keywords = [];

    const checkbox = document.getElementById("categoryFinalStates");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectFinalStates.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonFinalStatesAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectFinalStates.any = true;
    }

    const allButton = document.getElementById("buttonFinalStatesAll");
    if(allButton.classList.contains("chosen")){
        searchObjectFinalStates.any = false;
    }
    
    const buttonJets1jet = document.getElementById("buttonFinalStatesJets1jet");
    if(buttonJets1jet.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJets1jet.value)
    }
    
    const buttonJets2jets = document.getElementById("buttonFinalStatesJets2jets");
    if(buttonJets2jets.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJets2jets.value)
    }
    
    const buttonJets3jets = document.getElementById("buttonFinalStatesJets3jets");
    if(buttonJets3jets.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJets3jets.value)
    }
    
    const buttonJetsAllhadronic = document.getElementById("buttonFinalStatesJetsAllhadronic");
    if(buttonJetsAllhadronic.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJetsAllhadronic.value)
    }
    
    const buttonJetsBJets = document.getElementById("buttonFinalStatesJetsBJets");
    if(buttonJetsBJets.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJetsBJets.value)
    }
    
    const buttonJetsCJets = document.getElementById("buttonFinalStatesJetsCJets");
    if(buttonJetsCJets.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJetsCJets.value)
    }
    
    const buttonJetsBoostedSubstructure = document.getElementById("buttonFinalStatesJetsBoostedSubstructure");
    if(buttonJetsBoostedSubstructure.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJetsBoostedSubstructure.value)
    }
    
    const buttonJetsForwardjets = document.getElementById("buttonFinalStatesJetsForwardjets");
    if(buttonJetsForwardjets.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonJetsForwardjets.value)
    }
    
    const buttonSinglelepton = document.getElementById("buttonFinalStatesSinglelepton");
    if(buttonSinglelepton.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonSinglelepton.value)
    }
    
    const buttonDiLeptonOppositecharge = document.getElementById("buttonFinalStatesDiLeptonOppositecharge");
    if(buttonDiLeptonOppositecharge.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonDiLeptonOppositecharge.value)
    }
    
    const buttonDiLeptonSamecharge = document.getElementById("buttonFinalStatesDiLeptonSamecharge");
    if(buttonDiLeptonSamecharge.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(buttonDiLeptonSamecharge.value)
    }
    
    const button3leptons = document.getElementById("buttonFinalStates3leptons");
    if(button3leptons.classList.contains('selected')){
        searchObjectFinalStates.keywords.push(button3leptons.value)
    }
    
    getAllFiltered()

}